import React from 'react';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import GuestInfo from './GuestInfo';
import {BookingData, GuestData} from '../helperFunctions';
import {Group} from '../../../graphql/groups.datatypes';

const placeholderBookingData: BookingData = {
  id: -1,
  roomsData: [],
  billingPartiesData: [],
  nights: {
      start: moment(),
      end: moment(),
      mandatoryStart: moment(),
      mandatoryEnd: moment()
  },
  validData: []
};
const placeholderGuestData: GuestData = {
  id: 'placeholder',
  first_name: '',
  last_name: '',
  dob: moment().toString(),
  tour_role: -1,
  primary_occupant: false,
  isValid: true,
  roomGuestNumber: -1,
  billingPartyId: 'placeholder',
  roomId: 'placeholder',
  optionValues: []
};

interface Props {
  group: Group;
  guestIndex: number;
  roomGuestCount: number;
  addGuestHandler: () => void;
}

const GuestInfoPlaceholder = ({addGuestHandler, group, guestIndex, roomGuestCount}: Props) => (
  <GuestInfo
      isPlaceholder={true}
      bookingData={placeholderBookingData}
      group={group}
      guestData={placeholderGuestData}
      guestIndex={guestIndex}
      roomGuestCount={roomGuestCount}
      onClick={addGuestHandler}
      removeGuest={() => null}
      setGuestData={() => null}
    />
);

export default GuestInfoPlaceholder;